import React from 'react';
import styled from 'styled-components';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';

import { Section, Container } from '@components/global';

const About = () => (
  <StaticQuery
    query={graphql`
      query {
        art_fast: file(
          sourceInstanceName: { eq: "art" }
          name: { eq: "fast" }
        ) {
          childImageSharp {
            fluid(maxWidth: 760) {
              ...GatsbyImageSharpFluid_withWebp_tracedSVG
            }
          }
        }

        art_learn: file(
          sourceInstanceName: { eq: "art" }
          name: { eq: "learn_yourself" }
        ) {
          childImageSharp {
            fluid(maxWidth: 760) {
              ...GatsbyImageSharpFluid_withWebp_tracedSVG
            }
          }
        }

        art_ideas: file(
          sourceInstanceName: { eq: "art" }
          name: { eq: "ideas" }
        ) {
          childImageSharp {
            fluid(maxWidth: 760) {
              ...GatsbyImageSharpFluid_withWebp_tracedSVG
            }
          }
        }
      }
    `}
    render={data => (
      <Section id="about">
        <Container>
          <Grid>
            <div>
              <h2>The best talent for outreach!</h2>
              <p>
                Outreach Talent provides the highest quality for outreach agencies. 
                High quality management and extensive training have created a 
                ready to go workforce that will act as a force multiplier 
                for your agency.


                 <br />
                 <br />
                <a href="https://calendly.com/gritcult/60-min">Book a call now! &nbsp;&#x2794;</a>
              </p>
            </div>
            <Art>
              <Img fluid={data.art_fast.childImageSharp.fluid} />
            </Art>
          </Grid>
          <Grid inverse>
            <Art>
              <Img fluid={data.art_learn.childImageSharp.fluid} />
            </Art>
            <div>
              <h2>Cost free replacement!</h2>
              <p>
                We understand everyones needs are different and we will work with you
                to ensure that you have the best fit for your agency. 
                Working with us you ensure you have access to 
                highly trained staff at the forefront.
                 <br />
                 <br />
                <a href="https://calendly.com/gritcult/60-min">Book a call now! &nbsp;&#x2794;</a>
              </p>
            </div>
          </Grid>
          <Grid>
            <div>
              <h2>Grow and build your Team</h2>
              <p>
                Waste no more time on micromanaging. 
                Focus on the the agency you want to build and nothing more. 
                Leave the operations to us!

                <br />
                <br />
                  We are ready to scale along side you!
                 <br />
                 <br />
                <a href="https://calendly.com/gritcult/60-min">Book a call now! &nbsp;&#x2794;</a>
              </p>
            </div>
            <Art>
              <Img fluid={data.art_ideas.childImageSharp.fluid} />
            </Art>
          </Grid>
        </Container>
      </Section>
    )}
  />
);

const Grid = styled.div`
  display: grid;
  grid-template-columns: 3fr 2fr;
  grid-gap: 40px;
  text-align: right;
  align-items: center;
  justify-items: center;
  margin: 24px 0;

  ${props =>
    props.inverse &&
    `
    text-align: left;
    grid-template-columns: 2fr 3fr;
  `}

  h2 {
    margin-bottom: 16px;
  }

  @media (max-width: ${props => props.theme.screen.md}) {
    grid-template-columns: 1fr;
    text-align: left;
    margin-bottom: 96px;

    &:last-child {
      margin-bottom: 24px;
    }

    ${props =>
      props.inverse &&
      `
        ${Art} {
          order: 2;
        }
    `}
  }
`;

const Art = styled.figure`
  margin: 0;
  max-width: 380px;
  width: 100%;
`;

export default About;
